/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerFindByScopeIdQueryResponse, FilesControllerFindByScopeIdPathParams, FilesControllerFindByScopeIdQueryParams, FilesControllerFindByScopeId400, FilesControllerFindByScopeId401, FilesControllerFindByScopeId403, FilesControllerFindByScopeId404 } from "../../models/filesController/FilesControllerFindByScopeId";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerFindByScopeId } from "../../clients/filesService/filesControllerFindByScopeId";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerFindByScopeIdQueryKey = (scopeId: FilesControllerFindByScopeIdPathParams["scopeId"], params: FilesControllerFindByScopeIdQueryParams = {}) => [{
  url: '/api/v1/scopes/:scopeId/file',
  params: {
    scopeId: scopeId
  }
}, ...(params ? [params] : [])] as const;
export type FilesControllerFindByScopeIdQueryKey = ReturnType<typeof filesControllerFindByScopeIdQueryKey>;
export function filesControllerFindByScopeIdQueryOptions(scopeId: FilesControllerFindByScopeIdPathParams["scopeId"], params?: FilesControllerFindByScopeIdQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerFindByScopeIdQueryKey(scopeId, params);
  return queryOptions<FilesControllerFindByScopeIdQueryResponse, ResponseErrorConfig<FilesControllerFindByScopeId400 | FilesControllerFindByScopeId401 | FilesControllerFindByScopeId403 | FilesControllerFindByScopeId404>, FilesControllerFindByScopeIdQueryResponse, typeof queryKey>({
    enabled: !!scopeId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerFindByScopeId(scopeId, params, config);
    }
  });
}

/**
 * @summary Get a file by scope ID
 * {@link /api/v1/scopes/:scopeId/file}
 */
export function useFilesControllerFindByScopeId<TData = FilesControllerFindByScopeIdQueryResponse, TQueryData = FilesControllerFindByScopeIdQueryResponse, TQueryKey extends QueryKey = FilesControllerFindByScopeIdQueryKey>(scopeId: FilesControllerFindByScopeIdPathParams["scopeId"], params?: FilesControllerFindByScopeIdQueryParams, options: {
  query?: Partial<QueryObserverOptions<FilesControllerFindByScopeIdQueryResponse, ResponseErrorConfig<FilesControllerFindByScopeId400 | FilesControllerFindByScopeId401 | FilesControllerFindByScopeId403 | FilesControllerFindByScopeId404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerFindByScopeIdQueryKey(scopeId, params);
  const query = useQuery({
    ...filesControllerFindByScopeIdQueryOptions(scopeId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FilesControllerFindByScopeId400 | FilesControllerFindByScopeId401 | FilesControllerFindByScopeId403 | FilesControllerFindByScopeId404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}